var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#898E99",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3566_64018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92702 17.2102V15.5149L14.1777 8.81818H15.6394V11.1648H14.7743L12.0946 15.4055V15.4851H18.1351V17.2102H9.92702ZM14.8141 19V16.6932L14.8539 15.9425V8.81818H16.8723V19H14.8141Z",
    fill: "#898E99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3566_64018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 22,
    fill: "white",
    transform: "translate(9 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastReview);
export default __webpack_public_path__ + "static/media/BroadcastReview.7e43bb8f828d7d12d6a139520ef84b83.svg";
export { ForwardRef as ReactComponent };